import memoize from 'transmute/memoize';
export const PERCENT = 'percentage';
export const FIXED = 'fixed';
export const getDiscountOptions = memoize(currencyCode => [{
  text: '%',
  value: PERCENT
}, {
  text: currencyCode,
  value: FIXED
}]);